// extracted by mini-css-extract-plugin
module.exports = {"layout_wp":"layout-wrapper_layout_wp__NzADe"};